module.exports = __webpack_public_path__ + "img/polish-active.b90cfb0c.png";